import React from "react";

import { Props } from "./types";
import styles from "./styles.scss";

function CircularProgressBar({
  size,
  progress,
  strokeWidth,
  barColor,
  progressColor,
}: Props) {
  const center = size / 2;
  const radius = size / 2 - strokeWidth / 2;
  const circumference = 2 * Math.PI * radius;
  const offset = ((100 - progress) / 100) * circumference;

  return (
    <svg className={styles.progressBar} width={size} height={size}>
      <circle
        className={styles.bar}
        cx={center}
        cy={center}
        r={radius}
        strokeWidth={strokeWidth}
        style={barColor ? { stroke: barColor } : {}}
      />
      <circle
        className={styles.progress}
        cx={center}
        cy={center}
        r={radius}
        strokeWidth={strokeWidth}
        strokeDasharray={circumference}
        strokeDashoffset={offset}
        style={progressColor ? { stroke: progressColor } : {}}
      />
    </svg>
  );
}

export { CircularProgressBar };
